<template>
  <div class="box is-radiusless">
    <form @submit.prevent="submitForm">
      <div class="field">
        <label for="customer_name" class="label">Customer Name</label>
        <div class="control"><input class="input is-radiusless" required v-model="formData.name" type="text"></div>
      </div>
      <div class="field">
        <label for="contact_name" class="label">Contact Name</label>
        <div class="control"><input class="input is-radiusless" v-model="formData.contactName" type="text"></div>
      </div>
      <div class="field">
        <label for="address" class="label">Address</label>
        <div class="control"><input class="input is-radiusless" v-model="formData.address" type="text"></div>
      </div>
      <div class="field">
        <label for="address2" class="label">Address 2</label>
        <div class="control"><input class="input is-radiusless" v-model="formData.address2" type="text"></div>
      </div>
      <div class="columns">
        <div class="field column is-two-half">
          <label for="city" class="label">City</label>
          <div class="control"><input type="text" class="input is-radiusless" v-model="formData.city"></div>
        </div>
        <div class="field column">
          <label for="state" class="label">State</label>
          <div class="control"><input type="text" class="input is-radiusless" v-model="formData.state"></div>
        </div>
        <div class="field column">
          <label for="zip" class="label">Zip Code</label>
          <div class="control"><input type="text" class="input is-radiusless" v-model="formData.zip"></div>
        </div>
      </div>
      <div class="columns">
        <div class="field column">
          <label for="phone" class="label">Phone</label>
          <div class="control"><input type="tel" class="input is-radiusless" v-model="formData.phone"></div>
        </div>
        <div class="field column">
          <label for="cell" class="label">Cell</label>
          <div class="control"><input type="tel" class="input is-radiusless" v-model="formData.cell"></div>
        </div>
        <div class="field column">
          <label for="fax" class="label">Fax</label>
          <div class="control"><input type="tel" class="input is-radiusless" v-model="formData.fax"></div>
        </div>
      </div>
      <div class="field">
        <label for="email" class="label">Email</label>
        <div class="control"><input type="email" class="input is-radiusless" v-model="formData.email"></div>
      </div>
      <div class="field">
        <label for="notes" class="label">Notes</label>
        <div class="control"><textarea type="textarea" required class="textarea is-radiusless" v-model="formData.notes"></textarea></div>
      </div>
      <div class="field is-grouped is-grouped-centered">
        <div class="control"><a @click="cancelForm" class="button is-light is-radiusless">Cancel</a></div>
        <div class="control"><button type="submit" class="button is-primary is-radiusless">Save</button></div>
      </div>
    </form>
  </div>
</template>

<script>
import { postLead, patchLead } from '@/utils/api';
// import patchLead
export default {
  props: ['leadData'],
  watch: {
    leadData() {
      if (this.leadData) {
        const { leadId, ...leadData } = this.leadData;
        this.leadId = leadId;
        this.formData.name = leadData.name;
        this.formData.contactName = leadData.contactName;
        this.formData.address = leadData.address;
        this.formData.address2 = leadData.address2;
        this.formData.city = leadData.city;
        this.formData.state = leadData.state;
        this.formData.zip = leadData.zip;
        this.formData.phone = leadData.phone;
        this.formData.fax = leadData.fax;
        this.formData.cell = leadData.cell;
        this.formData.email = leadData.email;
        this.formData.notes = leadData.notes;
      }
    },
  },
  data() {
    return {
      leadId: null,
      formData: {
        name: null,
        contactName: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        phone: null,
        fax: null,
        cell: null,
        email: null,
        notes: '',
      },
    };
  },
  methods: {
    async submitForm() {
      try {
        if (this.leadData) {
          // if leadData was passed in, we assume this is an edit, not a creation
          const result = await patchLead(this.leadId, this.formData);
        } else {
          const result = await postLead(this.formData);
        }
        this.$emit('done', this.formData);
      } catch (err) {
        console.error(err);
      }
    },
    cancelForm() {
      this.$emit('cancel');
    },
  },
};
</script>
